import { render, staticRenderFns } from "./FlashCardView.vue?vue&type=template&id=2764201a&scoped=true&"
import script from "./FlashCardView.vue?vue&type=script&lang=js&"
export * from "./FlashCardView.vue?vue&type=script&lang=js&"
import style0 from "./FlashCardView.vue?vue&type=style&index=0&id=2764201a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764201a",
  null
  
)

export default component.exports